import { render } from "./Alert.vue?vue&type=template&id=603bff95&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=603bff95&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-603bff95"

export default script